import * as React from 'react';
import { connect } from 'react-redux';

import {
    getStaticText,
} from "../reducers/staticTexts";

import { getTranslations } from "../reducers/translations";

import StatsOverallPresentation  from '../presentations/StatsOverall/StatsOverallPresentation';
import { getActiveMatchId } from '../reducers/timings';
import { getStatsOverallForMatchId } from '../reducers/statsOverall';

const mapStateToProps = ( state: any ) => {
    let statsOverall = getStatsOverallForMatchId(state,getActiveMatchId(state));

    // TODO find a more elegant solution for missing content
    if (!statsOverall) {
        //console.log("statsOverall empty!!!");
        return {
            translations: getTranslations(state)
        };
    }

    // FIXME all of this deep data inspection belongs inside the reducer
    // fetch all necessary data from feed response
    let servicePointsHomeMade = statsOverall[141] ? String(statsOverall[141].value.home).split("/")[0] : 0;
    let servicePointsHomeOf = statsOverall[141] ? String(statsOverall[141].value.home).split("/")[2] : 0;
    let servicePointsAwayMade = statsOverall[141] ? String(statsOverall[141].value.away).split("/")[0] : 0;
    let servicePointsAwayOf = statsOverall[141] ? String(statsOverall[141].value.away).split("/")[2] : 0;
    let servicePointsObject = {
        home: servicePointsHomeMade,
        ofHome: servicePointsHomeOf,
        away: servicePointsAwayMade,
        ofAway: servicePointsAwayOf
    };

    let breakPointsHomeMade = statsOverall[139] ? String(statsOverall[139].value.home).split("/")[0] : 0;
    let breakPointsHomeOf = statsOverall[139] ? String(statsOverall[139].value.home).split("/")[1] : 0;
    let breakPointsAwayMade = statsOverall[139] ? String(statsOverall[139].value.away).split("/")[0] : 0;
    let breakPointsAwayOf = statsOverall[139] ? String(statsOverall[139].value.away).split("/")[1] : 0;
    let breakPointsObject = {
        home: breakPointsHomeMade,
        ofHome: breakPointsHomeOf,
        away: breakPointsAwayMade,
        ofAway: breakPointsAwayOf
    };

    let pointsHomeMade = statsOverall[136] && statsOverall[136].value.home ? statsOverall[136].value.home : 0;
    let pointsAwayMade = statsOverall[136] && statsOverall[136].value.away ? statsOverall[136].value.away : 0;
    let pointsObject = {
        home: pointsHomeMade,
        away: pointsAwayMade
    };

    let acesHomeMade = statsOverall[130] && statsOverall[130].value.home ? statsOverall[130].value.home : 0;
    let acesAwayMade = statsOverall[130] && statsOverall[130].value.away ? statsOverall[130].value.away : 0;
    let acesObject = {
        home: acesHomeMade,
        away: acesAwayMade
    };

    let last10PointsHome = statsOverall.last10Points.value.home ? statsOverall.last10Points.value.home : 0;
    let last10PointsAway = statsOverall.last10Points.value.away ? statsOverall.last10Points.value.away : 0;
    let last10PointsObject = {
        home: last10PointsHome,
        away: last10PointsAway
    };

    let doubleFaultsHomeMade = statsOverall[132] && statsOverall[132].value.home ? statsOverall[132].value.home : 0;
    let doubleFaultsAwayMade = statsOverall[132] && statsOverall[132].value.away ? statsOverall[132].value.away : 0;
    let doubleFaultsObject = {
        home: doubleFaultsHomeMade,
        away: doubleFaultsAwayMade
    };

    return {
        staticTexts: getStaticText( state ),
        translations: getTranslations( state ),
        servicePoints: servicePointsObject,
        breakPoints: breakPointsObject,
        points: pointsObject,
        aces: acesObject,
        last10Points: last10PointsObject,
        doubleFaults: doubleFaultsObject
    };
};

export default connect( mapStateToProps )( StatsOverallPresentation );
